import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import { REQUEST_FEEDBACK_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

export const transformAggJSMRequestFeedbackToLegacyField: FieldTransformer<
	typeof REQUEST_FEEDBACK_CF_TYPE
> = (node) => {
	if (node.type !== REQUEST_FEEDBACK_CF_TYPE) return undefined;

	return {
		...transformAggNodeToLegacyField(node),
		value: node.feedback,
		schema: {
			type: 'sd-feedback',
			renderer: PLAIN_TEXT,
			custom: REQUEST_FEEDBACK_CF_TYPE,
			system: null,
			items: null,
			configuration: null,
		},
	};
};
